module.exports = __webpack_public_path__ + "static/media/patient1.e7553b4d.jpg";